import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";

import { NotificationsAction } from "../../store/actions";

import { FaBell } from "react-icons/fa6";

import { Buttons, Modal, inputFields, Spacer } from "..";

import "./styles.css";
import { Images } from "../../config";

const StudentDeadlineRow = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split("/")[3];
  const appData = props?.item;

  const [notificationModal, setNotificationModal] = useState(false);
  const [notification, setNotification] = useState({
    text: "",
    title: "",
  });

  const handleNotify = () => {
    if (!notification?.title || !notification?.text) {
      message.error("Please fill all the fields");
      return;
    } else {
      const payload = { ...notification, user: id };
      dispatch(NotificationsAction.addNotificationsSingle(payload));
      setNotificationModal(false);
      setNotification({ title: "", text: "" });
    }
  };

  return (
    <div key={props.index} className="deadline-row">
      <div className="flex gap-3 w-full">
        <div className="approw-image-container">
          <img
            src={appData?.university?.profilePic ?? Images.LogoIconOnly}
            className="approw-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = Images.LogoIconOnly;
            }}
          />
        </div>
        <div className="flex flex-col justify-center gap-2 w-[83%]">
          <div className="app-row-heading">
            {appData?.university?.name} Application
          </div>
          <div className="app-row-subheading">{appData?.university?.name}</div>
        </div>
      </div>
      <div className="flex flex-col justify-center gap-2 pl-4">
        <div className="app-row-heading">
          {appData?.university?.deadlines?.length > 0
            ? appData?.university?.deadlines[0].deadlineType ??
              "Application Deadline"
            : "Application Deadline"}
        </div>
        <div className="app-row-subheading border border-main px-3 py-1 w-max rounded-lg">
          {appData?.university?.deadlines?.length > 0
            ? appData?.university?.deadlines[0].appDeadline
              ? moment(appData?.university?.deadlines[0].appDeadline).format(
                  "DD MMMM, YYYY"
                )
              : "NA"
            : "NA"}
        </div>
      </div>
      <div className="flex items-center justify-center">
        <Buttons.WhiteButton
          onClick={() => setNotificationModal(true)}
          style={{ height: "max-content" }}
          size="medium"
        >
          <div className="flex gap-2 overflow-hidden text-ellipsis">
            <FaBell className="text-pendingText text-[1.125em]" /> Send Reminder
            for Upcoming Deadline
          </div>
        </Buttons.WhiteButton>
      </div>
      <Modal.DefaultModal
        open={notificationModal}
        onCancel={() => setNotificationModal(false)}
      >
        <div className="flex flex-col items-center justify-center gap-4 px-5 py-4 text-center text-[1.125em] w-[37.5em]">
          <div className="text-main text-[1.5em] font-semibold">
            Notification For Student
          </div>

          <div className="flex flex-col gap-4 w-full">
            <div className="flex flex-col justify-left items-start gap-2">
              <div className="text-[1.125em] font-semibold pl-2">
                Notification Title
              </div>
              <inputFields.DefaultInput
                value={notification?.title}
                placeholder="Enter title"
                onChange={(e) =>
                  setNotification({ ...notification, title: e.target.value })
                }
              />
            </div>
            <div className="flex flex-col justify-left items-start gap-2">
              <div className="text-[1.125em] font-semibold pl-2">
                Notification Description
              </div>
              <inputFields.DefaultTextbox
                value={notification?.text}
                placeholder="Enter description"
                onChange={(e) =>
                  setNotification({ ...notification, text: e.target.value })
                }
              />
            </div>
          </div>
          <Spacer height={10} />

          <Buttons.DefaultButton onClick={handleNotify}>
            Send Notification
          </Buttons.DefaultButton>
        </div>
      </Modal.DefaultModal>
    </div>
  );
};

export default StudentDeadlineRow;
